import { useEffect, useState } from "react";

export function useIsMobile() {
    const [isMobile, setIsMobile] = useState(false);
  
    useEffect(() => {
      const checkMobile = () => {
        // Using 768px as the breakpoint (Tailwind's 'md' breakpoint)
        const mediaQuery = window.matchMedia('(max-width: 1023px)');
        setIsMobile(mediaQuery.matches);
      };
  
      // Check initial state
      checkMobile();
  
      // Listen for window resize
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
  
    return isMobile;
  }